import { render, staticRenderFns } from "./MenuTabs.vue?vue&type=template&id=b385fffa&scoped=true&"
import script from "./MenuTabs.vue?vue&type=script&lang=js&"
export * from "./MenuTabs.vue?vue&type=script&lang=js&"
import style0 from "./MenuTabs.vue?vue&type=style&index=0&id=b385fffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b385fffa",
  null
  
)

export default component.exports